export function tableHeight (thatObj) {
  return new Promise(resolve => {
    let tableOffsetTop = thatObj.$refs.table ? thatObj.$refs.table.$el.offsetTop : 0
    let paginationHeight = thatObj.$refs.pagination ? 0 : 48    //分页器高度thatObj.$refs.pagination.$el.offsetHeight
    var height = window.innerHeight - tableOffsetTop - 46 - 42 - 20 - 58 + paginationHeight    //46header部分、42tab部分、20背景页面paddingBottom、58分页部分、分页器高度
    resolve(height)
  })
}